"use client"
import {
  Button
} from "./chunk-AFVGPBIP.mjs";

// src/icon-button.tsx
import { forwardRef } from "@yamada-ui/core";
import { cx } from "@yamada-ui/utils";
import { jsx } from "react/jsx-runtime";
var IconButton = forwardRef(
  ({ className, children, icon, ...rest }, ref) => {
    return /* @__PURE__ */ jsx(
      Button,
      {
        ref,
        className: cx("ui-icon-button", className),
        p: 0,
        ...rest,
        children: icon || children
      }
    );
  }
);
IconButton.displayName = "IconButton";
IconButton.__ui__ = "IconButton";

export {
  IconButton
};
//# sourceMappingURL=chunk-QQERBTQW.mjs.map